import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, C, Card, ErrorNote, Muted, Title } from '../ui';
import { CommerceItem } from '../components';
import { useCommerces } from '../useCommerces';

type Filter = 'todos' | 'draft' | 'reclamado';

const CommerceList = () => {
  const navigate = useNavigate();
  const { commerces, loading, error } = useCommerces();
  const [filter, setFilter] = useState<Filter>('todos');

  const shown = commerces.filter((c) => filter === 'todos' || c.estado === filter);

  const tab = (key: Filter, label: string) => (
    <button
      type="button"
      onClick={() => setFilter(key)}
      style={{
        fontFamily: 'Poppins, sans-serif',
        fontSize: 13,
        fontWeight: filter === key ? 600 : 500,
        color: filter === key ? C.white : C.primary,
        background: filter === key ? C.secondary : C.white,
        border: `1px solid ${filter === key ? C.secondary : C.cardBorder}`,
        borderRadius: 6,
        padding: '6px 14px',
        cursor: 'pointer',
      }}
    >
      {label}
    </button>
  );

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
        <Title>Comercios</Title>
        <Button onClick={() => navigate('/partner/comercios/nuevo')}>Nuevo comercio</Button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
        {tab('todos', `Todos (${commerces.length})`)}
        {tab('draft', `Borradores (${commerces.filter((c) => c.estado === 'draft').length})`)}
        {tab('reclamado', `Reclamados (${commerces.filter((c) => c.estado === 'reclamado').length})`)}
      </div>

      <Card>
        {loading && <Muted>Cargando...</Muted>}
        {error && <ErrorNote>{error}</ErrorNote>}
        {!loading && shown.length === 0 && <Muted>No hay comercios en esta vista.</Muted>}
        {shown.map((c) => (
          <CommerceItem key={c.id_suscripcion} c={c} />
        ))}
      </Card>
    </>
  );
};

export default CommerceList;
